import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import Select from 'react-select';
import { FixedSizeList as List } from 'react-window';

export const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
};

export const toMoney = (x)=>{
    return(parseFloat(x).toLocaleString('en-US', {style: 'currency',currency: 'USD'}));
};

export const toPerc = (x, n_dec=2)=>{
    return(parseFloat(x).toFixed(n_dec) + "%");
};

export const toFixed = (x, n_dec=2)=>{
    return(parseFloat(x).toFixed(n_dec));
};

export const toFloat = (x)=>{
    return parseFloat(x);
};

export const ScrollToTop = () => {
  // Extracts pathname property(key) from an object
  const { pathname } = useLocation();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export const previous_date = (
  time_label,
  ref_date = null,
  asString = true
) => {
  // time_label : [500D, 1M, 3M, 1Y, MTD, YTD]
  // ref_date   : optional date string or Date object
  // asString   : true => "YYYY-MM-DD", false => Date object

  const baseDate = ref_date ? new Date(ref_date) : new Date();
  let prev_date = new Date(baseDate); // clone

  if (time_label === "YTD") {
    // Last day of previous year
    prev_date = new Date(baseDate.getFullYear() - 1, 11, 31);

  } else if (time_label === "MTD") {
    // Last day of previous month
    prev_date = new Date(baseDate.getFullYear(), baseDate.getMonth(), 0);

  } else if (time_label.endsWith("Y")) {
    const years = parseFloat(time_label.slice(0, -1));
    prev_date.setFullYear(baseDate.getFullYear() - years);

  } else if (time_label.endsWith("M")) {
    const months = parseFloat(time_label.slice(0, -1));
    prev_date.setMonth(baseDate.getMonth() - months);

  } else if (time_label.endsWith("D")) {
    const tradingDays = parseFloat(time_label.slice(0, -1));

    // Approximate trading days (5/week) as calendar days
    const calendarDays = Math.round(tradingDays * 7 / 5);
    prev_date.setDate(baseDate.getDate() - calendarDays);

  } else {
    prev_date = new Date(baseDate);
  }

  return asString
    ? prev_date.toISOString().split("T")[0]
    : prev_date;
};
export const pick = (obj, keys) => {
  return keys.reduce((acc, key) => {
    if (key in obj) acc[key] = obj[key];
    return acc;
  }, {});
};

export const array_diff = (arr1, arr2)=>{
  let arrdiff = arr1.filter(x => !arr2.includes(x));
  return arrdiff;
};

export const transpose = (arr, key, label) => {
    const row_names = array_diff(Object.keys(arr[0]), [key]);
    const arr_trans = row_names.map(name=>{
        const obj = arr.reduce((acc, item) => {
          acc[item[key]] = item[name];
          return acc;
        }, {});
        return {[label]:name, ...obj};
    });
    return arr_trans;
};

export const sum_array = (array) => {
    // Use the reduce() method to sum the elements of the array
    const sum = array.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    return sum;
}

export function argmax(arr) {
    return arr.reduce((maxIndex, currentValue, currentIndex, array) => {
        return currentValue > array[maxIndex] ? currentIndex : maxIndex;
    }, 0);
}

export const unique_values = (jsonArray, key) => {
  const uniqueValues = [];
  
  for (let i = 0; i < jsonArray.length; i++) {
    const value = jsonArray[i][key];
    
    if (!uniqueValues.includes(value)) {
      uniqueValues.push(value);
    }
  }
  
  return uniqueValues;
};

export const true_indices = (boolArray, add=0) => {
    const indices = [];
    boolArray.forEach((value, index) => {
        if (value === true) {
            indices.push(index + add);
        }
    });
    return indices;
};

  export const array_groupby = (data, key_name, value_name) => {
    let result = data.reduce((acc, item) => {
        // Check if the category already exists in the accumulator
        if (acc[item[key_name]]) {
            // If it exists, add the current value to the existing sum
            acc[item[key_name]] += item[value_name];
        } else {
            // If it doesn't exist, create a new key with the current value
            acc[item[key_name]] = item[value_name];
        }
        return acc;
    }, {});
    
    // Convert the object to an array of objects
    let groupedData = Object.keys(result).map(key => ({
        category: key,
        value: result[key]
    }));
    
    return groupedData;
};


export const weighted_array_groupby = (data, id, key_name, value_name, weights, factor=1) => {
    let result = data.reduce((acc, item) => {
        // Check if the category already exists in the accumulator
        if (acc[item[key_name]]) {
            // If it exists, add the current value to the existing sum
            acc[item[key_name]] += item[value_name]*weights.filter(x=>x.name==item[id])[0].weight*factor;
        } else {
            // If it doesn't exist, create a new key with the current value
            acc[item[key_name]] = item[value_name]*weights.filter(x=>x.name==item[id])[0].weight*factor;
        }
        return acc;
    }, {});
    
    // Convert the object to an array of objects
    let groupedData = Object.keys(result).map(key => ({
        name: key,
        value: result[key]
    }));
    
    return groupedData;
};

export const aggregate = (data, keyFields, accumFields) => {
  var createNewObj = (ref, fields) => {
    return fields.reduce((result, key) => {
      return Object.assign(result, { [key] : ref[key] });
    }, {});
  };
  return Object.values(data.reduce((result, object, index, ref) => {
    let key = keyFields.map(key => object[key]).join('');
    let val = result[key] || createNewObj(object, keyFields);
    for (let var_i of accumFields){
        val[var_i] = (val[var_i] || 0) + object[var_i];
    }
    return Object.assign(result, { [key] : val });
  }, {}));
};

const MenuList = (props) => {
  const { options, children, maxHeight, getValue, itemSize } = props;
  const [value] = getValue();
  const initialOffset = options.indexOf(value) * 50; // Adjust the height of each item as needed

  return (
    <List
      height={maxHeight}
      itemCount={children.length}
      itemSize={itemSize} // Adjust the height of each item as needed
      initialScrollOffset={initialOffset}
    >
      {({ index, style }) => <div style={style}>{children[index]}</div>}
    </List>
  );
};

export const sort_by = (
  properties,
  order = "asc",
  absolute = false
) => {
  // normalize to array of properties
  const props = Array.isArray(properties) ? properties : [properties];

  // normalize absolute flags
  const absFlags = Array.isArray(absolute)
    ? absolute
    : props.map(() => absolute);

  // helper to access nested values
  const getValue = (obj, prop) => {
    if (Array.isArray(prop)) {
      return prop.reduce((acc, key) => (acc ? acc[key] : undefined), obj);
    }
    return obj[prop];
  };

  return function (a, b) {
    for (let i = 0; i < props.length; i++) {
      let valA = getValue(a, props[i]);
      let valB = getValue(b, props[i]);

      if (absFlags[i]) {
        if (typeof valA === "number") valA = Math.abs(valA);
        if (typeof valB === "number") valB = Math.abs(valB);
      }

      if (valA < valB) return order === "asc" ? -1 : 1;
      if (valA > valB) return order === "asc" ? 1 : -1;
      // if equal, continue to next property
    }
    return 0;
  };
};

export const custom_sort_by = (data, property, customOrder) => {
  return data.sort((a, b) => {
    const indexA = customOrder.indexOf(a[property]);
    const indexB = customOrder.indexOf(b[property]);

    // If both not found, leave order as is
    if (indexA === -1 && indexB === -1) return 0;

    // If only one not found, put it at the end
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    // Otherwise sort by their position in customOrder
    return indexA - indexB;
  });
};


export const custom_sort_keys = (data, customOrder, placeUnmatched = "end") => {
  const sortedData = {};

  // Add keys in the specified custom order
  customOrder.forEach(key => {
    if (data.hasOwnProperty(key)) {
      sortedData[key] = data[key];
    }
  });
  // Find unmatched keys
  const unmatchedKeys = Object.keys(data).filter(key => !customOrder.includes(key));
  // Add unmatched keys at the beginning or end
  if (placeUnmatched === "start") {
    unmatchedKeys.forEach(key => {
      sortedData[key] = data[key];
    });

    // Then re-add the customOrder keys (since JS object keys maintain insertion order)
    const finalSortedData = {};
    unmatchedKeys.forEach(key => {
      finalSortedData[key] = sortedData[key];
    });
    customOrder.forEach(key => {
      if (data.hasOwnProperty(key)) {
        finalSortedData[key] = data[key];
      }
    });
    return finalSortedData;

  } else {
    // Add at the end (default)
    unmatchedKeys.forEach(key => {
      sortedData[key] = data[key];
    });
    return sortedData;
  }
};

export const sort_array_js = (array, property, ascending = false) => {
  const sorted = [...array].sort((a, b) => {
    if (ascending) {
      return a[property] - b[property];
    } else {
      return b[property] - a[property];
    }
  });
  return sorted;
};

export const remove_key_json_array = (array, key_to_remove) =>{
  var newArray = array.map(function(obj) {
      // Create a new object without the specified key
      const { [key_to_remove]: omittedKey, ...newObject } = obj;
      return newObject;
  });
  return newArray;
};

export const series_normalize = (series, variables, series_per, date_id='index', factor=1, ini_val=null)=>{
  if (!Array.isArray(series) || series.length === 0) {
    return null;
  }
  
  let prev_date = Date.parse(previous_date(series_per, series[0][date_id]));
  let series_filtered = variables.length===0 ? [] : series.filter(item=>Date.parse(item[date_id])>prev_date).map(x=>_.pick(x, [date_id].concat(variables)));

  const ini_pr =  series.filter(item=>Date.parse(item[date_id])>prev_date)[0];
  let norm_series = [...series_filtered];
  if (variables.length>1){
    if (ini_val==null){
      norm_series = norm_series.map(item=>{
        variables.forEach(x=>{
          item[x] = factor*(item[x]/ini_pr[x]-1);
        });
        return (item);
      });
    }else{
      norm_series = norm_series.map(item=>{
        variables.forEach(x=>{
          item[x] = ini_val*item[x]/ini_pr[x];
        });
        return (item);
      });
    }
  }
  return norm_series;
};

export const ordered_js = (unordered, start_elements)=>{
  let ordered_keys = start_elements.concat(array_diff(Object.keys(unordered),start_elements));
  const ordered = ordered_keys.reduce(
    (obj, key) => {
      obj[key] = unordered[key];
      return obj;
    },
    {}
  );
  return ordered;
};

export const filtered_json = (jsonData, keys) =>{
  const filteredJson = {};
  keys.forEach(key => {
    if (jsonData.hasOwnProperty(key)) {
      filteredJson[key] = jsonData[key];
    }
  });
  return filteredJson;
};

const customFilterOption = (option, inputValue) => {
  const words = inputValue.toLowerCase().split(' ').filter(Boolean);
  const label = option.label.toLowerCase();

  return words.every(word => label.includes(word));
};

export const CustomListSelect = (props) => {
  const customStyles = {
    singleValue: (base) => ({
      ...base,
      fontSize: props.fontSize || 14,
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: props.fontSize || 14,
    }),
    input: (base) => ({
      ...base,
      fontSize: props.fontSize || 14,
    }),
    control: (base) => ({
      ...base,
      fontSize: props.fontSize || 14,
      minHeight: 32,               // optional: shrink height
    }),
    menuList: (base) => ({
      ...base,
      fontSize: props.fontSize || 14,
    }),
    option: (base, state) => ({
      ...base,
      fontSize: props.fontSize || 14,
      backgroundColor: state.isSelected
        ? '#e0e0e0'
        : state.isFocused
        ? '#f2f2f2'
        : 'white',
      color: 'black',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: '2px',
      svg: {
        width: '12px',   // 👈 smaller arrow
        height: '12px',
      },
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: 2,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      paddingRight: '4px', // 👈 less right padding
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999, // ensure it floats on top
    }),
  };
  return (
    <Select
      maxMenuHeight={
        props.options && props.options.length > 0
          ? Math.min(props.options.length * (props.itemSize || 50), (props.maxMenuHeight || 250)) // adjust max height
          : (props.itemSize || 50)
      }

      name={props.name}
      value={props.value}
      options={props.options}
      isDisabled={props.isDisabled}
      isClearable={props.isClearable}
      onChange={props.onChange}
      filterOption={customFilterOption}
      components={{
        MenuList: (menuProps) => (
          <MenuList
            {...menuProps}
            itemSize={props.itemSize || 50}
          />
        ),
      }}
      className={props.className}
      placeholder={props.placeholder}
      styles={customStyles}
      // 👇 this moves the menu to <body>
      menuPortalTarget={document.body}
    />
  );
};

export const CustomSelect = (props) => {
  const customStyles = {
    singleValue: (provided) => ({
      ...provided,
      fontSize: props.fontSize || 14,
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: props.fontSize || 14,
    }),
    input: (provided) => ({
      ...provided,
      fontSize: props.fontSize || 14,
    }),
    control: (provided) => ({
      ...provided,
      fontSize: props.fontSize || 14,
    }),
    menuList: (provided) => ({
      ...provided,
      fontSize: props.fontSize || 14,   // 👈 controls the font size of the menu list
    }),
    option: (provided) => ({
      ...provided,
      fontSize: props.fontSize || 14
    }),
  };

  return (
    <Select
      isMulti
      maxMenuHeight={
        props.options && props.options.length > 0
          ? Math.min(props.options.length * (props.itemSize || 50), (props.maxMenuHeight || 250)) // adjust max height
          : (props.itemSize || 50)
      }
      name={props.name}
      value={props.value}
      options={props.options}
      filterOption={customFilterOption}
      isDisabled={props.isDisabled}
      onChange={props.onChange}
      components={{ MenuList: (menuProps) => <MenuList {...menuProps}  itemSize={props.itemSize || 50} /> }}
      className={props.className}
      placeholder={props.placeholder}
      styles={customStyles}
    />
  );
};

export const remove_keys_json_array = (array, keys_to_remove) => {
  var newArray = array.map(function (obj) {
    // Create a new object without the specified keys
    const newObject = Object.keys(obj).reduce((acc, key) => {
      if (!keys_to_remove.includes(key)) {
        acc[key] = obj[key];
      }
      return acc;
    }, {});
    return newObject;
  });
  return newArray;
};

export const filtered_data = (data, search_text) => {
  return data==null ? null : 
    (search_text!=null ? 
    data.filter(item => {
        return Object.keys(item).some(key =>
          item[key].toString().toLowerCase().includes(search_text.toLowerCase())
      );
      }
    ) : data);
};

export const reordered_array_keys = (arr, key) => {
  const reordered = arr.map(obj => {
    if (!(key in obj)) return obj;
  
    const { [key]: first, ...rest } = obj;
    return { [key]: first, ...rest };
  });
  return reordered;
};

export const add_perc_key = (data, key, factor=100) => {
  const total = data.reduce((sum, item) => sum + item[key], 0);
  
  const updatedData = data.map(item => ({
    ...item,
    percentage: (item[key] / total) * factor // or remove .toFixed(2) if you want a number
  }));

  return updatedData
}

export const valid_url = (string) => {
  try {
    new URL(string);
    return true;
  } catch (error) {
    return false;
  }
};


export const mergeByKey = (arrays, key="Date", mode="outer") => {
  const map = new Map();
  const allKeys = new Set();

  // Collect all possible non-key fields
  for (const arr of arrays) {
    for (const obj of arr) {
      for (const k of Object.keys(obj)) {
        if (k !== key) allKeys.add(k);
      }
    }
  }

  // Helper: empty row for a given key value
  const emptyRow = (val) => {
    const row = { [key]: val };
    for (const k of allKeys) row[k] = null;
    return row;
  };

  // Merge all arrays
  for (const arr of arrays) {
    for (const obj of arr) {
      const val = obj[key];
      if (!map.has(val)) {
        map.set(val, emptyRow(val));
      }
      Object.assign(map.get(val), obj);
    }
  }

  let result = Array.from(map.values());

  if (mode === "inner") {
    // Keep only key values present in all arrays
    const sets = arrays.map(arr => new Set(arr.map(o => o[key])));
    result = result.filter(r => sets.every(s => s.has(r[key])));
  }

  // Sort (if key is string/number and sortable)
  result.sort((a, b) => {
    if (typeof a[key] === "string") return a[key].localeCompare(b[key]);
    return a[key] - b[key];
  });

  return result;
};

export const latest_by_key = (data, id_key, order_key) => {
    return Object.values(
        data.reduce((acc, item) => {
            // If id is not in acc OR the current item has a later timestamp, update it
            if (!acc[item[id_key]] || item[order_key] > acc[item[id_key]][order_key]) {
                acc[item[id_key]] = item;
            }
            return acc;
        }, {})
    );
};